export default __webpack_public_path__ + "static/media/logo.b4951429.png";